<div class="timeline">
    <section class="day" *ngFor="let day of days">
        <h4 class="day-label">{{ day.label }}</h4>

        <ol class="entries">
            <li class="entry" *ngFor="let entry of day.entries" [ngClass]="'kind-' + entry.kind">
                <span class="entry-icon material-icons-outlined" aria-hidden="true">{{ entry.icon }}</span>

                <div class="entry-body">
                    <!-- what happened first; who and when after it, quieter -->
                    <div class="entry-head">
                        <span class="entry-what">{{ entry.title | translate: entry.titleParams }}</span>
                        <span class="entry-meta">
                            <span *ngIf="entry.user">{{ entry.user }} · </span>
                            <span *ngIf="entry.since">{{ timeOfDay(entry.since) }} – </span>{{ timeOfDay(entry.time) }}
                        </span>
                    </div>

                    <!-- the fields a save changed, a line each, as the list's pills -->
                    <div class="change" *ngFor="let change of entry.changes">
                        <span class="field" *ngIf="entry.changes.length > 1">{{ change.field | translate }}</span>
                        <ng-container *ngIf="change.oldReference !== null">
                            <dependent-choice
                                class="pill old {{ change.pillClass }}"
                                [topic]="change.topic"
                                [selectedId]="change.oldReference"
                                [labelOnDemand]="change.labeler"
                                [showLabel]="true"
                                [reduced]="true"
                                [isTicketContext]="true"
                                ></dependent-choice>
                            <mat-icon class="arrow" aria-hidden="true">arrow_forward</mat-icon>
                        </ng-container>
                        <dependent-choice
                            class="pill {{ change.pillClass }}"
                            [topic]="change.topic"
                            [selectedId]="change.reference"
                            [labelOnDemand]="change.labeler"
                            [showLabel]="true"
                            [reduced]="true"
                            [isTicketContext]="true"
                            ></dependent-choice>
                    </div>

                    <div class="entry-text" *ngIf="entry.text">{{ entry.text }}</div>

                    <ng-container *ngIf="entry.comment">
                        <div class="comment" [class.clamped]="entry.commentLong && !entry.expanded"
                             [innerHTML]="entry.comment"></div>
                        <button *ngIf="entry.commentLong" type="button" class="more" (click)="toggle(entry)">
                            {{ (entry.expanded ? 'timeline.less' : 'timeline.more') | translate }}
                        </button>
                    </ng-container>

                    <!-- every file: a thumbnail for an image, an icon and the name for the rest -->
                    <div class="previews" *ngIf="entry.attachments.length">
                        <ng-container *ngFor="let file of present(entry)">
                            <img *ngIf="file.preview; else fileTile" [src]="file.preview" [alt]="file.name"
                                 [title]="file.name" class="preview" />
                            <ng-template #fileTile>
                                <span class="file" [title]="file.name">
                                    <span class="material-icons-outlined file-icon" aria-hidden="true">{{ file.icon }}</span>
                                    <span class="file-name">{{ file.name }}</span>
                                </span>
                            </ng-template>
                        </ng-container>
                        <!-- the files removed since, all in one tile -->
                        <span class="file gone" *ngIf="goneCount(entry) as gone">
                            <span class="material-icons-outlined file-icon" aria-hidden="true">hide_source</span>
                            <span class="file-name">{{ 'timeline.media.gone' | translate: { count: gone } }}</span>
                        </span>
                    </div>
                </div>
            </li>
        </ol>
    </section>
</div>
